/**
 * スライダーの初期化を行う関数
 */
function initializeSliders() {
  // 共通の基本設定を定義
  const baseOptions = {
    type: "loop",
    perPage: 1,
    speed: 1000,
    arrows: false
  };
  
  // splide_01の初期化
  new Splide("#splide_01", {
    ...baseOptions,
    padding: "8.5%",
    gap: 16
  }).mount();
  
  // splide_02の初期化
  new Splide("#splide_02", baseOptions).mount();

  // splide_03の初期化
  new Splide("#splide_03", baseOptions).mount();

  // splide_04の初期化
  new Splide("#splide_04", {
    ...baseOptions,
    padding: "8.5%",
    gap: 16
  }).mount();
}

/**
 * FAQアコーディオン
 */
function initializeLpAccordion() {
  const accordionItems = document.querySelectorAll(".js-lpAccordion");

  accordionItems.forEach(item => {
    item.addEventListener("click", function() {
      const answer = this.nextElementSibling;

      if(!answer) return;

      if(answer.clientHeight === 0) {
        answer.style.maxHeight = answer.scrollHeight + "px";
        item.classList.add("is-active");
      } else {
        answer.style.maxHeight = null;
        item.classList.remove("is-active");
      }
    });
  });
}

/**
 * ページ内リンク（アンカーリンク）の設定
 */
function initializePageLinks(pageLinksId, positionHeight = 0) {
  const pageLinks = document.querySelectorAll(`a[href^="#${pageLinksId || ''}"]`);
  if (pageLinks.length === 0) return;
  
  pageLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute('href'));
      
      if (target) {
        const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - positionHeight;

        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }
    });
  });
}

/**
 * お問い合わせボタンの表示/非表示
*/
function toggleFloatingButton() {
  const floatButton = document.querySelector('.js-lpFloatButton');
  const contactArea = document.querySelector('.js-lpContactArea');
  
  if (!floatButton || !contactArea) return;
  
  const handleScroll = () => {
    const scrollY = window.scrollY || window.pageYOffset;
    const contactAreaPosition = contactArea.getBoundingClientRect();
    const isContactAreaVisible = 
      contactAreaPosition.top < window.innerHeight && 
      contactAreaPosition.bottom > 0;
    
    // 50px未満のスクロールでは非表示
    if (scrollY > 50) {
      if (isContactAreaVisible) {
        // コンタクトエリアが画面内に表示されている場合は非表示
        floatButton.classList.remove('is-active');
      } else {
        // コンタクトエリアが画面内に表示されていない場合は表示
        floatButton.classList.add('is-active');
      }
    } else {
      floatButton.classList.remove('is-active');
    }
  };

  handleScroll();
  window.addEventListener('scroll', handleScroll);
}

document.addEventListener("DOMContentLoaded", function () {
  initializeSliders();
  initializeLpAccordion();
  toggleFloatingButton();
  // ページ内リンク用の関数（※該当リンクのHTMLにnoscrollクラスを追加してください）
  initializePageLinks("lpContact", 0);
  initializePageLinks("serviceFullOrder", 56);
});
